import React, { Component } from "react";
import { ReduxConnect, Router } from "../../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import ProcesoComponent from "../../../components/comisionesMembresia/proceso/Proceso";
import { ProcesoStore, procesoStore } from "./Proceso.store";
import { ProcesoDispatcher, procesoDispatcher } from "./Proceso.dispatcher";
import Layout from "../../../components/layout";

interface Props extends ProcesoStore, ProcesoDispatcher {}
interface State {}

@Router()
@ReduxConnect(procesoStore, procesoDispatcher)
export default class ProcesoContainer extends Component<Props, State> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Proceso de Comisiones - Membresías" />
          <ProcesoComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
